import React from 'react';
import { translate } from 'react-i18next';
import firebase from '../firebase';
import user from '../Auth/user';
import compose from '../compose';
import AssChart from './AssChart';
import {SumBy, CumulativeSumByMultiple, SumByShowOnlyAmount} from './Functions';
import DateFilter from './DateFilter';

class SalesTab extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      allSales: [],
      filteredSales: null,
      previousFilter: null,
      currentFilter: null,
      filters: [],
      display: 'block'
    };
  }

  fetchSales = (startDate, endDate) => {
    const {firebase} = this.props;
    const {shopkeeperId} = this.props.user;
    firebase.database()
      .ref(`shopkeepers/${shopkeeperId}/sales`)
      .orderByChild('paidAt')
      .startAt(startDate.getTime())
      .endAt(endDate.getTime())
      .once('value', (snapshot) => {
        const allSales = [];
        snapshot.forEach((data) => {
          const sale = {
            key: data.key,
            ...data.val()
          };

          allSales.push(this.enhanceSale(sale));
        });
        const sales = allSales.filter((sale) => (sale.standName));
        this.setState({allSales: sales, filteredSales: sales});
      });
  }

  enhanceSale = (sale) => {
    const paidAt = new Date(sale.paidAt);
    sale.hour = '' + paidAt.getHours();
    sale.paidAtDate = paidAt;
    sale.paidAtDate.setHours(0,0,0,0);
    sale.userId = sale.userId.substring(5,12);

    sale.count = 1;
    sale.weekday = sale.paidAtDate.toLocaleString(this.props.user.language, {weekday: 'long'});
    sale.dayOfWeek = +sale.paidAtDate.getDay();
    sale.paidAtDateFormated = sale.paidAtDate.toLocaleDateString(this.props.user.language);
    sale.standName = sale.standId in this.props.stands ?
      this.props.stands[sale.standId].name : '';
    return sale;
  }

  onNewFilter = (key, value) => {
    const filters = this.state.filters;
    filters[key] = value;
    this.setState({filters});
  }

  cancelFilter = (key) => {
    const filters = this.state.filters;
    delete filters[key];
    this.setState({filters});
  }

  onFilterChange = (filter) => {
    const filteredSales = this.state.allSales.filter(filter);
    this.setState({filteredSales});
  }

  onEnlargeToggled = () => {
    // Forces redraw but flashes the screen
    this.setState({display: 'none'});
    setTimeout(() => this.setState({display: 'block'}), 1);
  }

  render() {
    const boxProps = {
      style: this.props.boxStyle,
      data: this.state.filteredSales,
      filters: this.state.filters,
      cancelFilter: this.cancelFilter,
      onNewFilter: this.onNewFilter,
      onEnlargeToggled: this.onEnlargeToggled
    };

    const {t} = this.props;

    return (
      <div style={{display: this.state.display}}>
        <DateFilter updateFunction={this.fetchSales}/>
        <div style={{clear: 'both'}}></div>
        <div style={{
          display: 'flex',
          flexFlow: 'row wrap',
          justifyContent: 'space-between',
        }}>

          <AssChart {...boxProps}
            chartType='PieChart'
            title={t('dashboard.sale.sumProduct')}
            aggregate={new SumBy('productName', 'price')} />

          <AssChart {...boxProps}
            chartType='PieChart'
            title={t('dashboard.sale.sumStand')}
            aggregate={new SumBy('standName', 'price')} />

          <AssChart {...boxProps}
            chartType='Table'
            title={t('dashboard.sale.top10')}
            aggregate={new SumByShowOnlyAmount(10, 'userId', 'price',t('user'), t('sale.total'))} />

          <AssChart {...boxProps}
            chartType='LineChart'
            title={t('dashboard.sale.cumuSumStandDate')}
            aggregate={new CumulativeSumByMultiple(['paidAtDateFormated', 'standName'], 'price')} />

          <AssChart {...boxProps}
            chartType='LineChart'
            title={t('dashboard.sale.cumuSumProductDate')}
            aggregate={new CumulativeSumByMultiple(['paidAtDateFormated', 'productName'], 'price')} />

          <AssChart {...boxProps}
            chartType='ColumnChart'
            title={t('dashboard.sale.sumDay')}
            aggregate={new SumBy('paidAtDateFormated', 'price', t('price'))} />

          <AssChart {...boxProps}
            chartType='ColumnChart'
            title={t('dashboard.sale.sumWeekday')}
            aggregate={new SumBy('weekday', 'count', t('amount'))}
            sortByCallback={(a, b) => ((a.dayOfWeek === 0 ? 7 : a.dayOfWeek) - (b.dayOfWeek === 0 ? 7 : b.dayOfWeek))} />

          <AssChart {...boxProps}
            chartType='AreaChart'
            title={t('dashboard.sale.sumTime')}
            aggregate={new SumBy('hour', 'count', t('amount'))} />

        </div>
      </div>
    );
  }
}

const enhance = compose(translate(), firebase, user);

export default enhance(SalesTab);



// WEBPACK FOOTER //
// ./src/Dashboard/SalesTab.js